import { DSRedirect, DSTagPage } from 'shared-definitions/types'
import { ApiResponse, ApiTagPageProps, ApiResponseRedirect } from 'data-source/types.wp'
import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { metaMapper, MetaMapperOpts } from 'data-source/mappers/metaMapper'
import {
  onePostWithAuthorMapper,
  OnePostWithAuthorMapperOpts,
} from 'data-source/mappers/onePostWithAuthorMapper'
import { paginationMapper } from 'data-source/mappers/paginationMapper'
import { redirectMapper } from 'data-source/mappers/redirectMapper'

interface CodecGetTagPageOpts extends MetaMapperOpts, OnePostWithAuthorMapperOpts {
  slug: string
  pagePath: string
}

export function codecGetTagPage(
  raw: ApiResponse<ApiTagPageProps> | ApiResponseRedirect,
  opts: CodecGetTagPageOpts
): DSTagPage | DSRedirect | null {
  if ('redirect' in raw) {
    return redirectMapper(raw)
  }

  if ('code' in raw) {
    return null
  }

  const input = raw.data
  if (!input.content.posts.length) {
    return null
  }

  return {
    slug: opts.slug,
    sections: null,
    ampPagePath: null,
    meta: metaMapper({ ...input, content: {} }, [input.tag], opts),
    head: headPropsMapper(input.head),
    pagePath: opts.pagePath,
    resource: 'tag-page',
    title: input.tag,
    subtitle: 'Pages tagged:',
    posts: {
      ...paginationMapper(input.content),
      items: input.content.posts.map(i => onePostWithAuthorMapper(i, opts)),
    },
  }
}
